// extracted by mini-css-extract-plugin
export default {"logo":"_5DOcK7Bh","logo--authenticated":"_5Dx5pxYn","logo--not-authenticated":"_5Dcfm0QQ","logo--hiden-image":"_5DePSaGu"};